import { useCallback, useState } from 'react';

const LOCAL_STORAGE_KEY = 'hasSeenAccountingDashboardOnboardingModal';

type ResultTuple = [boolean, (value: boolean) => void];

const useNeedsAccountingDashboardOnboardingModal = (): ResultTuple => {
  const [
    hasSeenAccountingDashboardOnboardingModal,
    setHasSeenAccountingDashboardOnboardingModal,
  ] = useState<boolean>(localStorage.getItem(LOCAL_STORAGE_KEY) === 'true');

  // Inverse the value since the returned value is "needs" instead of "seen"
  const updateHasSeenAccountingDashboardOnboardingModal = useCallback(
    (value: boolean) => {
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(!value));
      setHasSeenAccountingDashboardOnboardingModal(!value);
    },
    [],
  );

  return [
    !hasSeenAccountingDashboardOnboardingModal,
    updateHasSeenAccountingDashboardOnboardingModal,
  ];
};

export default useNeedsAccountingDashboardOnboardingModal;
